'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const toString = window.Symbol && window.Symbol.toStringTag;

const Blob = window.Blob;
if (Blob && !Blob.prototype[toString]) {
  Blob.prototype[toString] = 'Blob';
}

function FilePolyfill(data, name, options) {
  const blob = new Blob(data, options);
  const date = options && undefined !== options.lastModified // eslint-disable-line no-void
  ? new Date(options.lastModified) : new Date();
  Object.defineProperties(blob, {
    name: {
      value: name
    },
    lastModifiedDate: {
      value: date
    },
    lastModified: {
      value: +date
    },
    toString: {
      value() {
        return '[object File]';
      }
    }
  });
  if (toString) {
    Object.defineProperty(blob, toString, {
      value: 'File'
    });
  }
  return blob;
}
let File = window.File;
try {
  new File([], ''); // eslint-disable-line no-new
} catch (a) {
  File = FilePolyfill;
}
if (toString) {
  try {
    File.prototype[toString] = 'File';
  } catch (e) {}
}
var File$1 = File;

function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}

let FormData = window.FormData;
const normalize = (name, value, filename) => {
  const nextName = name + '';
  const nextFilename = filename !== undefined ? filename + '' : value && typeof value === 'object' && typeof value.name === 'string' ? value.name : 'blob';
  const nextValue = value instanceof Blob ? new File$1([value], nextFilename, {
    lastModified: value.lastModified,
    preview: value.preview,
    type: value.type
  }) : value + '';
  return [nextName, nextValue, nextFilename];
};
class FormDataPolyfill {
  static stack(formdata) {
    let list = FormDataPolyfill.map.get(formdata);
    if (!Array.isArray(list)) {
      list = [];
      FormDataPolyfill.map.set(formdata, list);
    }
    return list;
  }
  static blob(formdata) {
    const boundary = `----formdata-polyfill-${Math.random()}`;
    const chunks = [];
    for (const [name, value] of formdata) {
      chunks.push(`--${boundary}\r\n`);
      if (value instanceof Blob) {
        chunks.push(`Content-Disposition: form-data; name="${name}"; filename="${value.name}"\r\n`, `Content-Type: ${value.type || 'application/octet-stream'}\r\n\r\n`, value, '\r\n');
      } else {
        chunks.push(`Content-Disposition: form-data; name="${name}"\r\n\r\n${value}\r\n`);
      }
    }
    chunks.push(`--${boundary}--`);
    return new Blob(chunks, {
      type: `multipart/form-data; boundary=${boundary}`
    });
  }
  constructor(form) {
    if (!form) return this;
    for (const element of Array.from(form.elements)) {
      // Skip elements without a name or disabled
      if (!element || !(element instanceof window.HTMLElement) || !element.name || element.disabled) {
        continue;
      }
      switch (element.type) {
        case 'file':
          for (const file of Array.from(element.files || [])) {
            this.append(element.name, file);
          }
          continue;
        case 'select-multiple':
        case 'select-one':
          for (const option of Array.from(element.options)) {
            if (!option.disabled && option.selected) {
              this.append(element.name, option.value);
            }
          }
          continue;
        case 'checkbox':
        case 'radio':
          if (element.checked) {
            this.append(element.name, element.value);
          }
          continue;
        default:
          this.append(element.name, element.value);
      }
    }
  }
  append(name, value, filename) {
    FormDataPolyfill.stack(this).push(normalize(name, value, filename));
  }
  delete(name) {
    const key = name + '';
    FormDataPolyfill.map.set(this, FormDataPolyfill.stack(this).filter(([name]) => name !== key));
  }
  *entries() {
    for (const entry of FormDataPolyfill.stack(this)) {
      yield entry;
    }
  }
  forEach(callback, context) {
    for (const [name, value] of this) {
      callback.call(context, value, name, this);
    }
  }
  get(name) {
    const key = name + '';
    const [, value] = FormDataPolyfill.stack(this).find(([name]) => name === key) || [key, null]; // return null if nonexistent
    return value;
  }
  getAll(name) {
    const key = name + '';
    return FormDataPolyfill.stack(this).filter(([name]) => name === key).map(([, value]) => value);
  }
  has(name) {
    const key = name + '';
    return FormDataPolyfill.stack(this).find(([name]) => name === key) !== undefined;
  }
  *keys() {
    for (const [name] of this) {
      yield name;
    }
  }
  set(name, value, filename) {
    const key = name + '';
    const index = FormDataPolyfill.stack(this).findIndex(([name]) => name === key);
    if (index < 0) {
      this.append(name, value, filename);
    } else {
      this.delete(name);
      FormDataPolyfill.stack(this).splice(index, 0, normalize(name, value, filename));
    }
  }
  *values() {
    for (const [, value] of this) {
      yield value;
    }
  }

  /*::
     @@iterator(): Iterator<any> {
     // $FlowIgnore
     return this[Symbol.iterator]()
     }
   */

  // $FlowIgnore
  [Symbol.iterator]() {
    return this.entries();
  }
  toString() {
    return '[object FormData]';
  }
}
_defineProperty(FormDataPolyfill, "map", new WeakMap());
if (typeof FormData === 'undefined' || !FormData.prototype.keys ||
// There is a bug with the formData getAll function in Edge 18: https://github.com/jimmywarting/FormData/issues/80
window.navigator.userAgent.indexOf('Edge') > -1) {
  FormData = FormDataPolyfill;
}
window.FormData = FormData;
var FormData$1 = FormData;

if (window.FormData === FormDataPolyfill) {
  const _send = window.XMLHttpRequest && window.XMLHttpRequest.prototype.send;
  const _fetch = window.Request && window.fetch;
  if (_send) {
    window.XMLHttpRequest.prototype.send = function (data) {
      if (data instanceof FormDataPolyfill) {
        const blob = FormDataPolyfill.blob(data);
        this.setRequestHeader('Content-Type', blob.type);
        _send.call(this, blob);
      } else {
        _send.call(this, data);
      }
    };
  }
  if (_fetch) {
    const _fetch = window.fetch;
    window.fetch = function (input, init) {
      if (init && init.body && init.body instanceof FormDataPolyfill) {
        init.body = FormDataPolyfill.blob(init.body);
      }
      return _fetch(input, init);
    };
  }
}
var polyfill = window.FormData;

exports.Blob = Blob;
exports.File = File$1;
exports.FormData = FormData$1;
exports.default = polyfill;
//# sourceMappingURL=index.min.js.map
